module.exports = __webpack_public_path__ + "static/media/colicoli11.38502eca.webp";